import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isMobilePoliciesOpen, setIsMobilePoliciesOpen] = useState(false);

  const policiesRef = useRef(null);
  const loginRef = useRef(null);
  const location = useLocation();
  const hoverTimeout = useRef(null);
  // Brand palette pulled from the S.Meera logo (gold + charcoal),
  // replacing the previous blue theme.
  const GOLD = "#D4CB2F";
  const GOLD_DARK = "#A89F1E";
  const CHARCOAL = "#55534F";
  const CHARCOAL_DARK = "#3A3936";

  const openLoginDropdown = () => {
  if (hoverTimeout.current) {
    clearTimeout(hoverTimeout.current);
  }
  setIsLoginOpen(true);
};

const closeLoginDropdown = () => {
  hoverTimeout.current = setTimeout(() => {
    setIsLoginOpen(false);
  }, 150); // 150ms delay
};

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsMenuOpen(false);
    setIsPoliciesOpen(false);
    setIsLoginOpen(false);
    setIsMobilePoliciesOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setIsMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (policiesRef.current && !policiesRef.current.contains(e.target))
        setIsPoliciesOpen(false);
      if (loginRef.current && !loginRef.current.contains(e.target))
        setIsLoginOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // useEffect(() => {
  //   document.body.style.overflow = isMenuOpen ? "hidden" : "";
  //   return () => { document.body.style.overflow = ""; };
  // }, [isMenuOpen]);

  const policies = [
    { label: "Terms & Conditions",   to: "/term-of-use" },
    { label: "Shipping & Delivery",  to: "/shipping-delivery-policy" },
    { label: "Privacy Policy",       to: "/privacy-policy" },
    { label: "Cancellation Policy",  to: "/cancellation-policy" },
  ];

  const logins = [
    { label: "Customer Login",       href: "/app" },
    { label: "Leader/Agent Login",   href: "https://portal.smeerahealth.com/" },
  ];

  // helper for active nav link styling
  const navLink = (path) =>
    `font-semibold transition ${
      location.pathname === path
        ? "text-[#A89F1E]"
        : "text-[#55534F] hover:text-[#A89F1E]"
    }`;

  const isPolicyActive = policies.some((p) => p.to === location.pathname);

  return (
    <>
      <header className="w-full z-[9999999] px-3 lg:px-6 bg-white sticky top-0" >
        <div className="max-w-7xl mx-auto flex items-center justify-between " >
          <Link to="/" className="flex items-center gap-3 shrink-0">
                <img
                  src="/assets/images/smeera-new-bg.png"
                  alt="S.meera"
                  className="h-28 w-auto"
                />
              </Link>

          <div className=" backdrop-blur-xl p-2 lg:p-2  rounded-full px-4 lg:px-12 lg:w-[50%]">
            <div className="flex items-center justify-between">

              {/* Logo */}
              
              {/* Desktop Nav */}
              <nav className="hidden lg:flex items-center gap-10 text-[18px]">
                <Link to="/" className={navLink("/")}>Home</Link>
                <Link to="/about-us" className={navLink("/about-us")}>About Us</Link>
                <Link to="/plans" className={navLink("/plans")}>Plans</Link>

                {/* <div className="relative" ref={policiesRef}>
                  <button
                    onClick={() => {
                      setIsPoliciesOpen(!isPoliciesOpen);
                      setIsLoginOpen(false);
                    }}
                    className={`flex items-center gap-2 font-semibold transition ${
                      isPolicyActive
                        ? "text-[#A89F1E]"
                        : "text-[#55534F] hover:text-[#A89F1E]"
                    }`}
                  >
                    Policies
                    <i
                      className={`bi bi-chevron-down text-xs transition-transform duration-200 ${
                        isPoliciesOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {isPoliciesOpen && (
                    <ul className="absolute top-10 left-0 bg-white rounded-2xl shadow-xl p-2 min-w-[240px] z-50 border border-gray-100">
                      {policies.map((p) => (
                        <li key={p.to}>
                          <Link
                            to={p.to}
                            className={`block px-4 py-2.5 rounded-xl text-[18px] font-semibold transition ${
                              location.pathname === p.to
                                ? "bg-[#FBFAE9] text-[#A89F1E]"
                                : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
                            }`}
                            onClick={() => setIsPoliciesOpen(false)}
                          >
                            {p.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div> */}

                <Link to="/contact" className={navLink("/contact")}>Contact</Link>
              </nav>

              {/* Desktop Login Dropdown */}
              <div
                className="hidden lg:block relative"
                ref={loginRef}
                onMouseEnter={openLoginDropdown}
                onMouseLeave={closeLoginDropdown}
              >
                <button
                  onClick={() => {
                    setIsLoginOpen((prev) => !prev);
                    setIsPoliciesOpen(false);
                  }}
                  className="flex items-center gap-2 px-7 py-3 rounded-full font-semibold shadow-lg hover:scale-105 text-[18px] text-white transition-all duration-200"
                  style={{
                    background: `linear-gradient(90deg, ${GOLD} 0%, ${CHARCOAL} 100%)`,
                    boxShadow: "0 10px 35px rgba(212,203,47,0.3)",
                  }}
                >
                  Login
                  <i
                    className={`bi bi-chevron-down text-xs transition-transform duration-200 ${
                      isLoginOpen ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {isLoginOpen && (
 
  <div
    className="absolute top-full right-0 pt-2 min-w-[250px] z-[100]"
    onMouseEnter={openLoginDropdown}
    onMouseLeave={closeLoginDropdown}
  >
    <ul className="bg-white rounded-2xl shadow-xl p-2 border border-gray-100">
      {logins.map((l) => (
        <li key={l.label}>
          <a
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            className=" block px-4 py-2.5 text-[18px] rounded-xl text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E] transition font-semibold"
            onClick={() => setIsLoginOpen(false)}
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
)}
              </div>

              {/* Mobile Hamburger */}
              <button
                onClick={() => setIsMenuOpen(true)}
                className="lg:hidden w-12 h-12 rounded-full text-white flex items-center justify-center outline-none focus:outline-none active:outline-none"
                style={{
                  background: `linear-gradient(90deg, ${GOLD} 0%, ${CHARCOAL} 100%)`,
                  WebkitTapHighlightColor: "transparent",
                }}
              >
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                >
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          className="h-[1px] max-w-7xl mx-auto"
          style={{
            background: `linear-gradient(90deg, ${GOLD} 40%, ${CHARCOAL} 80%)`,
            boxShadow: "0 10px 35px rgba(212,203,47,0.3)",
          }}
        />
      </header>

      {/* Mobile Backdrop */}
      <div
        onClick={() => setIsMenuOpen(false)}
        className={`fixed inset-0 bg-black/40 backdrop-blur-sm z-[60] lg:hidden transition-opacity duration-300 ${
          isMenuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      />

      {/* Mobile Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-[300px] bg-white z-[70] lg:hidden shadow-2xl transition-transform duration-300 ease-in-out flex flex-col ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Drawer Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <img
                  src="/assets/images/smeera-new-bg.png"
                  alt="S.meera"
                  className="w-20 h-20 object-cover"
                />
          <button
            onClick={() => setIsMenuOpen(false)}
            className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-gray-200 transition outline-none focus:outline-none"
            style={{ WebkitTapHighlightColor: "transparent" }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="4" y1="4" x2="20" y2="20" />
              <line x1="20" y1="4" x2="4" y2="20" />
            </svg>
          </button>
        </div>

        {/* Drawer Links */}
        <nav className="flex flex-col px-4 py-6 gap-1 flex-1 overflow-y-auto">
          <Link
            to="/"
            className={`flex items-center gap-3 px-4 py-3 rounded-2xl font-medium transition ${
              location.pathname === "/"
                ? "bg-[#FBFAE9] text-[#A89F1E]"
                : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
            }`}
          >
            <i className="bi bi-house text-lg" />
            Home
          </Link>

          <Link
            to="/about-us"
            className={`flex items-center gap-3 px-4 py-3 rounded-2xl font-medium transition ${
              location.pathname === "/about-us"
                ? "bg-[#FBFAE9] text-[#A89F1E]"
                : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
            }`}
          >
            <i className="bi bi-house text-lg" />
            About Us
          </Link>

          <Link
            to="/plans"
            className={`flex items-center gap-3 px-4 py-3 rounded-2xl font-medium transition ${
              location.pathname === "/plans"
                ? "bg-[#FBFAE9] text-[#A89F1E]"
                : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
            }`}
          >
            <i className="bi bi-grid text-lg" />
            Plans
          </Link>

          {/* Mobile Policies Accordion */}
          {/* <div>
            <button
              onClick={() => setIsMobilePoliciesOpen(!isMobilePoliciesOpen)}
              className={`w-full flex items-center justify-between gap-3 px-4 py-3 rounded-2xl font-medium transition ${
                isPolicyActive
                  ? "bg-[#FBFAE9] text-[#A89F1E]"
                  : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
              }`}
            >
              <span className="flex items-center gap-3">
                <i className="bi bi-shield-check text-lg" />
                Policies
              </span>
              <i
                className={`bi bi-chevron-down text-sm transition-transform duration-200 ${
                  isMobilePoliciesOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                isMobilePoliciesOpen ? "max-h-60" : "max-h-0"
              }`}
            >
              <div className="ml-4 mt-1 flex flex-col gap-1 border-l-2 border-[#D4CB2F]/40 pl-3">
                {policies.map((p) => (
                  <Link
                    key={p.to}
                    to={p.to}
                    className={`px-3 py-2 rounded-xl text-sm transition ${
                      location.pathname === p.to
                        ? "bg-[#FBFAE9] text-[#A89F1E] font-medium"
                        : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
                    }`}
                  >
                    {p.label}
                  </Link>
                ))}
              </div>
            </div>
          </div> */}

          <Link
            to="/contact"
            className={`flex items-center gap-3 px-4 py-3 rounded-2xl font-medium transition ${
              location.pathname === "/contact"
                ? "bg-[#FBFAE9] text-[#A89F1E]"
                : "text-[#55534F] hover:bg-[#FBFAE9] hover:text-[#A89F1E]"
            }`}
          >
            <i className="bi bi-telephone text-lg" />
            Contact
          </Link>
        </nav>

        {/* Mobile Login at Bottom */}
        <div className="px-4 pb-8 border-t border-gray-100 pt-4">
          <p className="text-xs text-gray-400 uppercase tracking-widest mb-3 px-2">
            Login As
          </p>
          <div className="flex flex-col gap-2">
            {logins.map((l) => (
              <a
                key={l.label}
                href={l.href}
                target={l.href.startsWith("http") ? "_blank" : "_self"}
                rel="noopener noreferrer"
                className="flex items-center gap-3 px-4 py-3 rounded-2xl text-white font-medium transition-all duration-200"
                style={{
                  background: `linear-gradient(90deg, ${GOLD} 0%, ${CHARCOAL} 100%)`,
                  boxShadow: "0 10px 35px rgba(212,203,47,0.3)",
                }}
              >
                <i className="bi bi-person text-lg" />
                {l.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;